import { motion } from "framer-motion";

const NavLink = ({ href, label, testId }) => (
  <a
    href={href}
    data-testid={testId}
    className="group relative font-mono text-xs uppercase tracking-[0.2em] text-bone/60 transition-colors duration-300 hover:text-bone"
  >
    {label}
    <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-gold transition-transform duration-300 group-hover:scale-x-100" />
  </a>
);

export const Header = ({ t, lang, setLang }) => (
  <motion.header
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, delay: 0.2, ease: [0.76, 0, 0.24, 1] }}
    className="fixed top-0 z-50 w-full border-b border-white/5 bg-ink/60 backdrop-blur-xl"
    data-testid="site-header"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
      <a href="#top" data-testid="logo-link" className="flex items-center gap-3">
        <img
          src="/images/logo.png"
          alt="CebolaFishing Guide"
          className="h-12 w-auto"
          data-testid="logo-image"
        />
        <span className="hidden font-mono text-[10px] uppercase tracking-[0.3em] text-bone/40 sm:inline">
          Alqueva · Portugal
        </span>
      </a>

      <nav className="hidden items-center gap-10 md:flex" data-testid="main-nav">
        <NavLink href="#apresentacao" label={t.nav.about} testId="nav-about-link" />
        <NavLink href="#especies" label={t.nav.species} testId="nav-species-link" />
        <NavLink href="#galeria" label={t.nav.gallery} testId="nav-gallery-link" />
        <NavLink href="#contactos" label={t.nav.contact} testId="nav-contact-link" />
      </nav>

      <div className="flex items-center gap-1 font-mono text-xs tracking-[0.2em]" data-testid="lang-toggle">
        <button
          data-testid="lang-toggle-pt"
          onClick={() => setLang("pt")}
          className={`px-2 py-1 transition-colors duration-300 ${lang === "pt" ? "text-gold" : "text-bone/40 hover:text-bone"}`}
        >
          PT
        </button>
        <span className="text-bone/20">|</span>
        <button
          data-testid="lang-toggle-en"
          onClick={() => setLang("en")}
          className={`px-2 py-1 transition-colors duration-300 ${lang === "en" ? "text-gold" : "text-bone/40 hover:text-bone"}`}
        >
          EN
        </button>
        <span className="text-bone/20">|</span>
        <button
          data-testid="lang-toggle-fr"
          onClick={() => setLang("fr")}
          className={`px-2 py-1 transition-colors duration-300 ${lang === "fr" ? "text-gold" : "text-bone/40 hover:text-bone"}`}
        >
          FR
        </button>
      </div>
    </div>
  </motion.header>
);
